import BaseComponent from "../../baseComponent.js";
import LineChart from "./lineChart.jsx";
import ExpandChart from "./expandChart.jsx";
import InternalEvent from "../../../core/constants/internalEvent.js";

export default class AutoHedge extends BaseComponent {
  componentDidMount() {
    if (this.props.volume !== "") {
      this.autoHedgeBody = <div id="auto-hedge-body" style={{opacity: '0'}}>
        <ExpandChart volume={this.props.volume}/>
        <LineChart />
      </div>
      this.forceUpdate();
      setTimeout(function () {
        $('#auto-hedge-body').css('display', 'none').css('opacity', '1').fadeIn({duration: 600});
      }, 1500);
    } else {
      setTimeout(function () {
        this.autoHedgeBody = <div id="auto-hedge-body" style={{opacity: '0'}}>
          <ExpandChart volume={this.props.volume}/>
          <LineChart />
        </div>
        this.forceUpdate();

      }.bind(this), 1500);// 1500
    }
  }

  componentDidUpdate() {
    $('#auto-hedge-body').css('opacity', '0');

    setTimeout(() => {
      this.publish(InternalEvent.App.HIDE_PRELOADER);
      $('#auto-hedge-body').css('display', 'none').css('opacity', '0').fadeIn({duration: 600});
    }, 500);// 1500
  }


  onSearchStringChange() {
    if (this.searchTimeout != null) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(function () {
      $('#auto-hedge-body').css('display', 'none');
      setTimeout(function () {
        $('#auto-hedge-body').css('display', 'none').css('opacity', '1').fadeIn({duration: 600});
      }, 1500);
    }, 700);
  }

  render() {
    return (
      <div id="auto-hedge-container">
        {this.autoHedgeBody}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/auto-hedging-widget/autoHedge.jsx